// extracted by mini-css-extract-plugin
export default {"avatar":"peer-skills-assessment_avatar__AuOut","card":"peer-skills-assessment_card__07QCw"};